// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uK4VZLWzuScQrUjFvLR5{color:var(--content-neutral-primary);display:flex}.QYc_T1ZxHv4zgv0LRf3e{width:250px}.rUlGWQskb_sanunA5trn,.Ew1sw4XShXgkMD3sDP2Q{line-height:15.99px}.Ew1sw4XShXgkMD3sDP2Q{color:var(--content-primary-primary-inverted)}.co8Tb1p_BomMKnorej5h{margin-left:-3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `uK4VZLWzuScQrUjFvLR5`,
	"wrap": `QYc_T1ZxHv4zgv0LRf3e`,
	"label": `rUlGWQskb_sanunA5trn`,
	"desc": `Ew1sw4XShXgkMD3sDP2Q`,
	"tooltip": `co8Tb1p_BomMKnorej5h`
};
export default ___CSS_LOADER_EXPORT___;
